import React, { useEffect, useRef } from "react";
import scrollToComponent from "react-scroll-to-component";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import { FreightHeadline } from "../styled";

const mapPackageTypeToCopyIdPrefix = {
  pallet: "ShipmentLaneComponent.Pallet.Title",
  containers: "ShipmentLaneComponent.Containers.Title",
  looseGoods: "ShipmentLaneComponent.LooseGoods.Title",
  parcels: "ShipmentLaneComponent.Parcel.Title",
  truckload: "ShipmentLaneComponent.Truckload.Title",
};

export const PackageItemList = injectIntl(
  ({ intl, packageCategory, children }) => {
    const ref = useRef();
    useEffect(() => {
      scrollToComponent(ref.current, {
        offset: -120,
        align: "top",
      });
    }, []);
    return (
      <div className="mx-wrapper">
        <FreightHeadline
          weight="800"
          priority={2}
          ref={ref}
          headlineDisplayType="h"
          className="grid-maxWidthInner no-padding"
        >
          {intl.formatMessage({
            id: packageCategory
              ? mapPackageTypeToCopyIdPrefix[packageCategory]
              : "ShipmentLaneComponent.headline",
          })}
        </FreightHeadline>
        {children}
      </div>
    );
  }
);

PackageItemList.propTypes = {
  packageCategory: PropTypes.string,
  children: PropTypes.node.isRequired,
};
